import React, { useContext, useState, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import moment from "moment";
import { Helmet } from "react-helmet";
import PageNavigations from "../breadcrumbs/PageNavigations";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePermissions } from "../contexts/PermissionContext";
import { SessionContext } from "../SessionProvider";

const ContactView = (props) => {
  const { selectedSessionId, setSelectedSessionId, currentSessionId } = useContext(SessionContext);
  const [isCurrentSession, setIsCurrentSession] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [contact, setContact] = useState(location.state ? location.state : {});
  const [modalShow, setModalShow] = useState(false);
  const { rolePermissions, userInfo } = usePermissions();
  const canEdit = rolePermissions?.Employee_List?.can_edit;
  const canDelete = rolePermissions?.Employee_List?.can_delete;
  const [previouseEmployerData , setPreviousEmployerData] = useState();


  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log("error=>", error);
      }
    }
    init();
  }, [selectedSessionId, isCurrentSession]);

  useEffect(() => {
    fetchContact();
  }, []);

  function bufferToUrl(bufferData) {
    const uint8Array = new Uint8Array(bufferData);
    const blob = new Blob([uint8Array], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  }

  const fetchContact = () => {
    try {
      if (location.hasOwnProperty("pathname")) {
        contact.id = location.pathname.split("/")[2];
      }
      async function initContact() {
        try {
          console.log("initContact == ", contact.id);
          let result = await schoolApi.fetchContact(contact.id);
          console.log("fetchContact == ", result);
          if (result.success) {
            setPreviousEmployerData(result?.contactRec?.previousEmployers || []);
            setContact(result.contactRec);
          } else {
            console.log("else");
            // toast.error(result.message);
            setContact({});
          }
        } catch (error) {
          // toast.error(error.response.data.message);
        }
      }
      initContact();
    } catch (error) {
      console.log("catch");
      toast.error(error.response.data.message);
    }
  };

  const deleteContact = async () => {
    try {
      const result = await schoolApi.deleteContact(contact.id);
      if (result.success === false) {
        toast.error(result.message);
        return;
      } else if (result.success === true) {
        toast.success("Record Deleted successfully");

        setTimeout(() => {
          navigate(
            location?.pathname?.split("/")[1] === "staff"
              ? "/staffs"
              : "/driver"
          );
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const editContact = () => {
    if (location?.pathname?.split("/")[1] === "staff") {
      navigate(`/staff/${contact.id}/e`, { state: contact });
    } else {
      navigate(`/driver/${contact.id}/e`, { state: contact });
    }
  };

  const downloadFile = (buffer, filename) => {
    if (!buffer) return;
    const blob = new Blob([new Uint8Array(buffer)]);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const FilePreview = ({ buffer, filename }) => {
    if (!buffer) return null;
  
    const blobUrl = bufferToUrl(buffer);
  
    if (filename.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {
      return <img src={blobUrl} alt={filename} height={70} width={70} onClick={() => downloadFile(buffer, filename)} />;
    }

    const downloadUrl = URL.createObjectURL(new Blob([new Uint8Array(buffer)]));
  
    // For non-image files, show a file icon with a download button
    return (
      <div className="file-preview">
        <span className="fs-5">{filename} </span> 
        {/* (Click to Download) */}
        <a href={downloadUrl} download={filename}>
          <i class="fa fa-cloud-download fs-5"></i>
        </a>
      </div>
    );
  }

  console.log("contact-viewpage-->>", contact);
  console.log("previouseEmployerData-viewpage-->>", previouseEmployerData);

  return (
    <>
      <Helmet><title>{props?.tabName}</title>{" "}</Helmet>
      <div>
        {contact && (
          <Container>

            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                deleteContact={deleteContact}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="contact"
              />
            )}
            <PageNavigations
              listName={
                contact?.recordtype === "Driver" ? "DriverView" : "EmployeeView"
              }
              listPath={
                contact?.recordtype === "Driver" ? "/driver" : "/staffs"
              }
              viewName=""
              viewPath=""
              colLg={2}
              colClassName="d-flex mx-3 mb-3"
              extrColumn={12}
            />

            <Row className="view-form">
              <Col lg={12}>
                <Row className="view-form-header align-items-center mx-2">
                  <Col lg={3}>
                    <h5>{contact.recordtype}</h5>
                    <h5>
                      {contact.salutation} {contact.firstname}{" "}
                      {contact.lastname}
                    </h5>
                  </Col>
                  <Col lg={9} className="d-flex justify-content-end">
                    {(userInfo?.userrole === "SYS_ADMIN" ||
                      userInfo?.userrole === "ADMIN" ||
                      canEdit) && (
                      <Button
                        className="btn-sm mx-2 edit-button"
                        onClick={() => editContact(true)}
                        disabled={isCurrentSession === false ? true : false}
                      >
                        <i className="fa-regular fa-pen-to-square"></i>
                      </Button>
                    )}
                    {(userInfo?.userrole === "SYS_ADMIN" ||
                      userInfo?.userrole === "ADMIN" ||
                      canDelete) && (
                      <Button
                        className="btn-sm"
                        variant="danger"
                        onClick={() => setModalShow(true)}
                        disabled={isCurrentSession === false ? true : false}
                      >
                        Delete
                      </Button>
                    )}
                    <ToastContainer
                      position="top-right"
                      autoClose={2000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="light"
                    />
                  </Col>
                </Row>
                <Row className="align-items-center mx-2">
                  <Col className="section-header my-3" lg={12}>
                    <span style={{ color: "black" }}>{contact?.recordtype === "Driver" ? "Driver" : "Employee"}{" "}Details</span>
                  </Col>
                </Row>
                <Row>
                  <Col lg={1}></Col>
                  <Col lg={5}>
                    <label>Name</label>
                    <span>
                      {contact.salutation} {contact.firstname}{" "}
                      {contact.lastname}
                    </span>
                  </Col>

                  <Col lg={5}>
                    <label>Gender</label>
                    {contact.gender ? (
                      <span>{contact.gender}</span>
                    ) : (
                      <>
                        <span>
                          <br />
                        </span>
                      </>
                    )}
                  </Col>

                  <Col lg={1}></Col>
                  <Col lg={1}></Col>
                  <Col lg={5}>
                    <label>Date of Birth</label>
                    {contact.dateofbirth ? (
                      <span>{moment(contact.dateofbirth).format("DD-MM-YYYY")}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>
                  <Col lg={5}>
                    <label>Employee Type</label>
                    <span>{contact.recordtype}</span>
                  </Col>
                  <Col lg={1}></Col>
                  <Col lg={1}></Col>
                  <Col lg={5}>
                    <label>Email</label>
                    {contact.email ? (
                      <span>{contact.email}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={5}>
                    <label>Phone</label>
                    {contact.phone ? (
                      <span>{contact.phone}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={1}></Col>
                  <Col lg={1}></Col>
                  <Col lg={5}>
                    <label>Aadhar number</label>
                    {contact.adharnumber ? (
                      <span>{contact.adharnumber}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={5}>
                    <label>Qualification</label>
                    {contact.qualification ? (
                      <span>{contact.qualification}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={1}></Col>
                  <Col lg={1}></Col>
                  <Col lg={5}>
                    <label>Religion</label>
                    {contact.religion ? (
                      <span>{contact.religion}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={5}>
                    <label>Street</label>
                    {contact.street ? (
                      <span>{contact.street}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={1}></Col>
                  <Col lg={1}></Col>
                  <Col lg={5}>
                    <label>City</label>
                    {contact.city ? (
                      <span>{contact.city}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={5}>
                    <label>Pincode</label>
                    {contact.pincode ? (
                      <span>{contact.pincode}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={1}></Col>
                  <Col lg={1}></Col>
                  <Col lg={5}>
                    <label>State</label>
                    {contact.state ? (
                      <span>{contact.state}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={5}>
                    <label>Country</label>

                    {contact.country ? (
                      <span>{contact.country}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>
                  <Col lg={1}></Col>
                  <Col lg={1}></Col>

                  <Col lg={5}>
                    <label>Session</label>
                    {contact.session ? (
                      <span>{contact.session}</span>
                    ) : (
                      <span>
                        <br />
                      </span>
                    )}
                  </Col>

                  <Col lg={5}>
        <label>Status</label>
        <span>{contact.status === true ? "Active" : "Inactive"}</span>
    </Col>

                  <Col></Col>
                </Row>
                <Row></Row>
              </Col>
              <Col></Col>

              {/* employee document */}
              <div className="d-flex justify-content-center gap-4 my-5">
                <FilePreview buffer={contact?.profile_image?.data} filename="Profile_Image.png" />
                <FilePreview buffer={contact?.aadhar_card?.data} filename="Aadhar_Card.pdf" />
                <FilePreview buffer={contact?.driving_license?.data} filename="Driving_License.pdf" />
                <FilePreview buffer={contact?.pan_card?.data} filename="Pan_Card.pdf" />

                {previouseEmployerData &&
                  previouseEmployerData.map((item, index) => (
                    <FilePreview buffer={item?.experience_letter?.data} filename={`experience_letter-${index+1}.pdf`} />
                  ))
                }
              </div>
              
            </Row>
            
          </Container>
        )}
      </div>
    </>
  );
};
export default ContactView;
